import { initTabSystem } from './utils/tabs';

document.addEventListener('DOMContentLoaded', function () {
  const contentContainer = document.getElementById('rubber-mixtures-content');

  const animateScaleHighlight = (panel, delay = 250) => {
    if (!panel) return;
    const highlight = panel.querySelector('.rubber-mixtures__scale-highlight');
    if (highlight) {
      const min = parseFloat(highlight.getAttribute('data-min'));
      const max = parseFloat(highlight.getAttribute('data-max'));

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (prefersReducedMotion) {
        highlight.style.transition = 'none';
        highlight.style.left = `${min}%`;
        highlight.style.width = `${max - min}%`;
        return;
      }

      // Reset instantly
      highlight.style.transition = 'none';
      highlight.style.width = '0';
      highlight.style.left = `${min}%`;

      // Animate after double requestAnimationFrame to ensure the reset is painted without layout thrashing
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          highlight.style.transition = '';
          setTimeout(() => {
            highlight.style.width = `${max - min}%`;
          }, delay);
        });
      });
    }
  };

  initTabSystem({
    tabsContainerSelector: '#rubber-mixtures-tabs',
    panelsContainerSelector: '#rubber-mixtures-content',
    tabSelector: '.rubber-mixtures__tab',
    panelSelector: '.rubber-mixtures__panel',
    bgImageSelector: '#rubber-mixtures-bg-image',
    bgContainerSelector: '#rubber-mixtures-bg',
    titleSelector: '#rubber-mixtures-title',
    onTabChange: (activePanel, isAlreadyActive) => {
      if (!isAlreadyActive) {
        animateScaleHighlight(activePanel, 250);
      }
    },
  });

  // Animate initial active panel scale highlight on load
  if (contentContainer) {
    const initialActivePanel = contentContainer.querySelector(
      '.rubber-mixtures__panel.active',
    );
    if (initialActivePanel) {
      animateScaleHighlight(initialActivePanel, 500);
    }
  }
});
